import { Box } from '@material-ui/core';

import { FormDoc, Team, TimeAndAttendanceLocation, User } from '@vyce/core/src/types';
import { FormProvider } from 'react-hook-form';
import { noop } from 'lodash';

import { FormSelectRecipients } from './components/FormSelectRecipients';
import { useFormRecipients } from './hooks/useFormRecipients';
import { useCreateFormData } from './hooks/useCreateFormData';

export const FormSettings: React.FC<{
  form: FormDoc | null;
  user: User;
  companyId: string;
  locations: TimeAndAttendanceLocation[];
  teams?: Team[];
}> = ({ form, user, companyId, locations, teams = [] }) => {
  const { createForm, updateForm, setSelectRecipientsOpen, onSendToResourceWorkers } = useCreateFormData({
    companyId,
    form,
    user,
  });

  const {
    isPhoneInputDisabled,
    handleEmailFieldKeyDown,
    handlePhoneFieldKeyDown,
    addEmailToList,
    addPhoneToList,
    deleteContact,
    emails,
    phones,
    selectedWorkers,
    toggleWorker,
    setIsPhoneInputDisabled,
    bulkPaste,
    bulkLimitHint,
    recipientsFormMethods,
    sendFormRecipients,
  } = useFormRecipients({ user, companyId, form });

  return (
    <Box>
      <FormProvider {...recipientsFormMethods}>
        <form onSubmit={recipientsFormMethods.handleSubmit(noop)}>
          <FormSelectRecipients
            companyId={companyId}
            userId={user.uuid}
            locations={locations}
            teams={teams}
            createForm={createForm}
            updateForm={updateForm}
            resourceIds={form?.resourceIds || []}
            sendFormRecipients={sendFormRecipients}
            hideRecipientsStep={() => setSelectRecipientsOpen(false)}
            isPhoneInputDisabled={isPhoneInputDisabled}
            handleEmailFieldKeyDown={handleEmailFieldKeyDown}
            handlePhoneFieldKeyDown={handlePhoneFieldKeyDown}
            addEmailToList={addEmailToList}
            addPhoneToList={addPhoneToList}
            deleteContact={deleteContact}
            emails={emails}
            phones={phones}
            selectedWorkers={selectedWorkers}
            toggleWorker={toggleWorker}
            saveButtonTitle="Save Changes"
            setIsPhoneInputDisabled={setIsPhoneInputDisabled}
            bulkPaste={bulkPaste}
            bulkLimitHint={bulkLimitHint}
            onSendToResourceWorkers={onSendToResourceWorkers}
            availableScopes={['team', 'location']}
            combinedLinkedView
            hideBackButton
          />
        </form>
      </FormProvider>
    </Box>
  );
};
